import React, { useState, useEffect } from "react";
import {
  Container,
  CustomDivider,
  PropertyForm,
  UserInfoForm,
} from "components";
import {
  InputFormField,
  DropdownFormField,
  DatePickerFormField,
} from "components/hookForm";
import styles from "../../transactionDetails.module.scss";
import { DropdownOptions } from "interfaces";
import { ICustomLabels } from "interfaces/IWhitelabelConfigurationResponse";
import { useFormContext, useWatch } from "react-hook-form";
import { DATE_FORMAT_YYYY_MM_DD } from "constants/datePicker";
import { formatDateToMMDDYYYY } from "tools/format";
import { formatDate, amountIsValid } from "tools/validators";
import { isDate } from "moment";

interface LossDraftComponentProps {
  statesOptions?: DropdownOptions[];
  customLabels?: ICustomLabels;
    companyId?: number;
}

const LossDraftComponent: React.FC<LossDraftComponentProps> = (props) => {
  const { getValues, setValue, control } = useFormContext();
    const {statesOptions, customLabels, companyId} = props;
  const [dateOfLoss, setDateOfLoss] = useState<Date>(new Date());

  const selectedRoleWatch = useWatch({
    control,
    name: "trrole",
    defaultValue: getValues("trrole") || "",
  });

  useEffect(() => {
    if (!getValues("lossDraftDateOfLoss")) {
      setValue("lossDraftDateOfLoss", formatDateToMMDDYYYY(new Date()));
    }
  }, []);

  // Loss type options
  const lossTypeOptions = [
    { value: "Animal/Pest Damage", label: "Animal/Pest Damage" },
    { value: "Earthquake", label: "Earthquake" },
    { value: "Fire", label: "Fire" },
    { value: "Flood", label: "Flood" },
    { value: "FEMA Structure Elevation", label: "FEMA Structure Elevation" },
    { value: "Flood w/ Mold", label: "Flood w/ Mold" },
    { value: "Hail", label: "Hail" },
    { value: "Homicide/Suicide", label: "Homicide/Suicide" },
    { value: "Hurricane", label: "Hurricane" },
    { value: "Ice Damage", label: "Ice Damage" },
    { value: "Landslide/Mudslide", label: "Landslide/Mudslide" },
    { value: "Lightning", label: "Lightning" },
    { value: "Mold", label: "Mold" },
    { value: "Puff Back (chimney soot)", label: "Puff Back (chimney soot)" },
    { value: "Sewage/Septic Tank", label: "Sewage/Septic Tank" },
    { value: "Smoke Damage", label: "Smoke Damage" },
    { value: "Sink Hole", label: "Sink Hole" },
    { value: "Tornado", label: "Tornado" },
    { value: "Tree Damage", label: "Tree Damage" },
    { value: "Tropical Storm", label: "Tropical Storm" },
    { value: "Unknown", label: "Unknown" },
    {
      value: "Vandalism/Malicious Mischief",
      label: "Vandalism/Malicious Mischief",
    },
    { value: "Vehicular Damage", label: "Vehicular Damage" },
    { value: "Water Damage", label: "Water Damage" },
    { value: "Wind w/ Hail", label: "Wind w/ Hail" },
    { value: "Wind", label: "Wind" },
    { value: "Windstorm", label: "Windstorm" },
    { value: "Water Damage w/Mold", label: "Water Damage w/Mold" },
  ];

  React.useEffect(() => {
    if (getValues("trrole") === "") {
      setValue("buyerFirstName", undefined);
      setValue("buyerLastName", undefined);
      setValue("buyerEmail", undefined);
      setValue("buyerPhone", undefined);
    }
  }, [selectedRoleWatch]);

  return (
    <Container className={styles.transactionDetailContainer}>
      <Container>
        <CustomDivider title="Your Info" />
        <UserInfoForm selectedRole={"clientPayment"} />
        <CustomDivider title="Loss Draft Information" />
        <Container className={styles.lossDraftContainer}>
          <InputFormField
            name="lossDraftRefId"
            label="Ref ID (Optional)"
            maxLength={32}
          />
          <InputFormField
            name="lossDraftLoanNumber"
            label={companyId === 514 ? "Installment Contract (include leading zeros)" : "Loan Number (Include leading zeros)"}
            required
            maxLength={32}
          />
          <InputFormField
            name="lossDraftPolicyNumber"
            label="Policy #"
            required
            maxLength={32}
          />
          <DropdownFormField
            name="lossDraftTypeOfLoss"
            label="Type of Loss"
            options={lossTypeOptions}
            required
          />
          <DatePickerFormField
            name={"lossDraftDateOfLoss"}
            onChange={(e: React.ChangeEvent<any> | null) => {
              isDate(e) && setDateOfLoss(e);
              isDate(e) &&
                setValue("lossDraftDateOfLoss", formatDateToMMDDYYYY(e));
            }}
            minDate={new Date("01/01/2015")}
            inputFormat={DATE_FORMAT_YYYY_MM_DD}
            value={
              getValues("lossDraftDateOfLoss")
                ? new Date(formatDate(getValues("lossDraftDateOfLoss")))
                : dateOfLoss
            }
            label={"Date of Loss"}
          />
          <InputFormField
            name="lossDraftClaimAmount"
            label="Claim Amount"
            maxLength={13}
            defaultValue={
              getValues("lossDraftClaimAmount")
                ? getValues("lossDraftClaimAmount")
                : "0"
            }
            currency={true}
            validate={(textFieldValue: string) => amountIsValid(textFieldValue)}
            required
          />
          <InputFormField
            name="lossDraftClaimNumber"
            label="Claim #"
            required
            maxLength={32}
          />
        </Container>
        <CustomDivider title="Property Details" />
        <PropertyForm
          statesOptions={statesOptions}
          customLabels={customLabels?.address}
        />
      </Container>
    </Container>
  );
};

export default LossDraftComponent;
